import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { PortalConfig } from 'src/context/portalConfigContext';
import { getCustomizedLabels } from 'src/utils/getCustomizedLabels';

import translation from './translations/en-US.json';

export const i18n = i18next.use(initReactI18next);

const DEFAULT_LANGUAGE = 'en';
const DEFAULT_NAMESPACE = 'translation';

void i18n.init({
  lng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  react: {
    useSuspense: false,
  },
});

i18n.services.formatter?.add('lowercase', (value: string) =>
  value.toLowerCase(),
);

export function isI18nResourceLoaded(): boolean {
  return i18n.hasResourceBundle(DEFAULT_LANGUAGE, DEFAULT_NAMESPACE);
}

export function loadI18nResources({
  customLabels,
}: {
  customLabels: PortalConfig['features']['customLabels'] | null;
}): void {
  i18n.addResourceBundle(
    DEFAULT_LANGUAGE,
    DEFAULT_NAMESPACE,
    {
      ...translation,
      ...getCustomizedLabels({ customLabels }),
    },
    true,
  );
}

export function reloadI18nResources({
  customLabels,
}: {
  customLabels: PortalConfig['features']['customLabels'] | null;
}) {
  i18n.removeResourceBundle(DEFAULT_LANGUAGE, DEFAULT_NAMESPACE);
  loadI18nResources({ customLabels });
}
